<template>
  <div id="marketcarousel">
    <!-- <SvgKinesis /> -->
    <div class="row text-white">
      <h1 class="text-title mt-5 ms-3">Our Services</h1>
      <div id="Adscarousel" class="carousel slide mb-4" data-bs-ride="carousel">
        <ol class="carousel-indicators">
          <template v-for="(ct, key) in contents">
        <button type="button" data-bs-target="#Adscarousel" :data-bs-slide-to="key" :class="{ active: key === 0 }" :key="key" aria-current="true"></button>
          </template>
        </ol>
        <div class="carousel-inner">
          <template v-for="(ct, key) in contents">
            <div class="carousel-item marketcars-image" :class="{ active: key === 0 }" :key="key">
              <div class="col d-flex justify-content-center">
                <div class="card bg-transparent border-0 px-3 py-3">
                  <img :src="ct.imgUrl" class="card-img-top rounded mx-auto d-block" />
                  <div class="card-body">
                    <h4 class="card-title text-center">{{ ct.title }}</h4>
                    <p class="card-text text-center mb-2 p-3">
                      {{ ct.text }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
          <button class="carousel-control-prev" type="button" data-bs-target="#Adscarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#Adscarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
      </div>
    </div>
  </div>
</template>

<script>
// import SvgKinesis from "@/components/KinesisTriangle";
export default {
  name: "markerAdscaro",
  components: {
    // SvgKinesis,
  },

  data: () => ({
    contents: [
      {
        imgUrl: "img/Best_Profesionnal_Tech.png",
        title: "PROFESSIONAL TECHNICIAN",
        text:
          "Our professional technicians are ready to help you handle complaints quickly, precisely, and responsively.",
      },
      {
        imgUrl: "img/Best_Services_ Cares.png",
        title: "BEST SERVICES AND CARE",
        text:
          "We provide maintenance contract solutions for our concern for you, man on site can be the best choice for you.",
      },
      {
        imgUrl: "img/Best_Warranty.png",
        title: "BEST WARRANTY",
        text:
          "We provide the best offer for warranty as our reference to be better, because your problem is our concern.",
      },
    ],
  }),
};
</script>

<style>
/* #marketcarousel .bg {
  margin-right: -30px;
  margin-left: -30px;
  padding-bottom: 3rem !important;
  padding-top: 3rem !important;
  background: #000000;
  clip-path: polygon(0 0, 100% 10%, 100% 100%, 0 90%);
} */

#marketcarousel .text-title {
  /* line-height: 5rem;
  margin-left: 5%; */
}
#marketcarousel .text-title {
  font-size: 48px;
  font-weight: bolder;
}
#Adscarousel .carousel-caption {
  height: 100px;
  top: 40;
  bottom: auto;
}
/* #Adscarousel .card .card-img-top {
  width: 50%;
  height: 25%;
} */
/* #Adscarousel .carousel-indicators {
  margin-top: 90%;
} */
/* #Adscarousel .carousel-inner img {
  margin-top: 0%;
  margin-bottom: 0%;
} */

#Adscarousel .card-body {
  padding-top: 0%;
  padding-bottom: 5%;
  padding-left: 10%;
  padding-right: 10%;
}

#Adscarousel .card-img-top {
  width: 25%;
}

#Adscarousel .img {
  /* padding-top: 0%;
  padding-bottom: 0%;
  background-repeat: no-repeat;
  background-position: center bottom;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover; */
}
#Adscarousel .stretched-link {
  font-size: 28px;
  position: absolute;
}
@media screen and (max-width: 640px) {
  #Adscarousel .card-img-top {
    width: 100%;
  }
  #marketcarousel .text-title {
    font-size: 25px;
  }
  #Adscarousel .card-body {
    padding-top: 0%;
    padding-bottom: 10%;
    padding-left: 10%;
    padding-right: 10%;
  }
  #Adscarousel .card .card-body .card-title {
    font-size: 18px;
  }
  #Adscarousel .card .card-body .card-text {
    font-size: 12px;
  }
  #Adscarousel .card .card-img-250-top {
    width: 75%;
  }
}
</style>
